import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import Registration from "../views/Registration";
import Consultation from "../views/Consultation";
import BOT from "../views/BOT";
import Supply from "../views/supply";	

export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'registration' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Registration/>
		} else if(
			appContext.navSubItem === 'consultation' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Consultation/>
		} else if(
			appContext.navSubItem === 'BOT' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <BOT/>
		} else if(
			appContext.navSubItem === 'supply' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Supply/>
		} 
			return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}